<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
            div.pull-right.m-t-sm
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="onLoading('save-stock-request')",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green(
                    :disabled="onLoading('save-stock-request')",
                    @click="submit",
                )
                    v-loading(loader="save-stock-request") Create

            nav(aria-label="breadcrumb")
                ol.breadcrumb.white.m-b-0.p-b-0
                    li.breadcrumb-item
                        router-link(to="/") Stock Request
                    li.breadcrumb-item.active Create
    .padding
        .box
            .box-header.dker
                h3 New Stock Request
            .box-divider.m-a-0
            .box-body
                .p-a
                    step-wizard

                form
                    fieldset(:disabled="onLoading('save-stock-request')")
                        .row
                            .col-md-5
                                .form-group
                                    label Source Outlet
                                    outlet-selector(
                                        :class="{'has-error': errors.has('Source Outlet') }"
                                        v-model="request.request_from_outlet_id",
                                        :exclude-id="request.request_to_outlet_id",
                                        :use-vuex="false",
                                        :user-outlet-only="false"
                                    )
                                    span.text-danger(v-if="errors.has('Source Outlet')")
                                        | {{ errors.first('Source Outlet') }}

                                .form-group
                                    label Destination Outlet
                                    outlet-selector(
                                        :class="{'has-error': errors.has('Destination Outlet') }"
                                        v-model="request.request_to_outlet_id",
                                        :exclude-id="request.request_from_outlet_id",
                                        :use-vuex="false",
                                    )
                                    span.text-danger(v-if="errors.has('Destination Outlet')")
                                        | {{ errors.first('Destination Outlet') }}
                                
                                .form-group
                                    label Prefer Transfer Date
                                    .row
                                        .col-xs-12
                                            vue-datepicker(
                                                type="datetime",
                                                width="100%",
                                                v-model="transferDate",
                                                :disabled="onLoading('save-stock-request')",
                                                lang="en",
                                                :editable="false",
                                                :clearable="false",
                                                :shortcuts="false",
                                                format="DD/MM/YYYY hh:mm:ss a"
                                                :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                                            )
</template>

<script>
import stockRequestMixin from './stock-request-mixin';
import stepWizard from './stock-request-step.vue';
import { mapActions } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { stepWizard },

    mixins: [stockRequestMixin],

    data() {
        return {
            request: {
                request_from_outlet_id: null,
                request_to_outlet_id: null,
                preferred_stock_transfer_date: moment().format(),
            },
            hasValidationError: false,
        };
    },

    computed: {
        transferDate: {
            get() {
                return this.request.preferred_stock_transfer_date;
            },
            set(date) {
                this.request.preferred_stock_transfer_date = moment(
                    date,
                ).format();
            },
        },
    },

    methods: {
        ...mapActions('stockRequest', ['createStockRequest']),

        cancel() {
            this.$router.push('/');
        },

        async submit() {
            this.errors.clear();
            this.hasValidationError = false;

            this.validateField(
                this.request.request_from_outlet_id,
                'Source Outlet',
            );

            this.validateField(
                this.request.request_to_outlet_id,
                'Destination Outlet',
            );

            if (this.hasValidationError) return;

            try {
                const stockRequest = await this.createStockRequest(
                    this.request,
                );
                this.$router.push(`/${stockRequest.id}`);
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        validateField(value, field) {
            if (_.isNull(value) || value == 0 || String(value).trim() == '') {
                this.errors.add({
                    field: field,
                    msg: `The ${field} field is required`,
                });

                this.hasValidationError = true;

                return false;
            }

            return true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-create.vue